export async function syncProjectSnapshot(payload: Record<string, unknown>): Promise<{ ok: boolean; syncedAt?: string; serverFile?: string; message?: string }> {
  const response = await fetch("/api/sync/project", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = (await response.json()) as { ok: boolean; syncedAt?: string; serverFile?: string; message?: string };
  if (!response.ok || !data.ok) {
    throw new Error(data.message || "同步失败，请稍后重试。");
  }
  return data;
}
